module.exports = __webpack_public_path__ + "static/media/prevDisabled.ab33860f.svg";